import React, { useEffect, useState } from "react";
import DonutChart from "../admin/components/Charts/DonutChart";
import DropDownWithLabel from "../admin/components/common/DropDownWithlable";
import DonutChartWithToolbar from "./graph";
import { API_RESPONSE } from "../utills/app-constant";
import {
  getAllCampaignByCompanyId,
  getAllCompanies,
  getAllDimenstionbycampaign,
} from "../services/api-services";
import { toastEmitter } from "../utills/utilities";
import DimensionDetails from "./dimenstion";
import RadialDimension from "./radial";
import RadialDimensionHorizontal from "./radialdimension";
import WeightedGapChart from "./weightedgraph";
import DmmSubdimensionsChart from "./dmmmodal";
import MaturityLine from "./maturity";
import OverallParticipationChart from "./overallparticipation";
import DivisionHeatmap from "./heatmap/divisionheatmap";
import OverallParticipationChartJobLevel from "./joblevelchart";
import JobHeatMap from "./heatmap/jobheatmap";
import DimessionDeepDive from "./dimensiondeepdive";
import CustomerMaturityLine from "./customermaturity";
import DimenstionCurrentChart from "./dimensioncurrent";
import DimenstionFutureChart from "./dimensionfuture";
import MaturityBenchmark from "./maturitybenchmark";
import SubDimensionCharts from "./radarchart";
import { FILTER_ICON, RIGHTARROW_ICON } from "../utills/image-constant";
import MultiDropdown from "../admin/components/common/MultiDropdown";
import TableHeading from "../admin/components/common/TableHeading";
import Dimension from "./heatmap/heatmap";
import DivisionLevelHeatmap from "./heatmap/divisionlebvelheatmap";
// import DivisionLevelHeatmap from "./heatmap/divisionlevelheatmap";

const NewResult = () => {
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedCampaignId, setSelectedCampaignId] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [campaignList, setCampaignList] = useState([]);
  const [selectedDimensionLabel, setSelectedDimensionLabel] = useState("");
  const [pending, setPending] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [selectedSection, setSelectedSection] = useState("survey");
  const [dimensionList, setDimensionList] = useState([]);
  const [selectedDimensionId, setSelectedDimensionId] = useState("");

  const getallCompany = async () => {
    setPending(true);
    try {
      const response = await getAllCompanies();
      if (response?.data?.responseCode === 200) {
        const companyOptions = response?.data?.responseBody.map((data) => ({
          value: data?.id,
          label: data?.companyName,
          Status: data?.status,
        }));
        setCompanyList(companyOptions);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  const handleCompanySelect = async (event) => {
    const companyId = event.target.value;
    setSelectedCompanyId(companyId);
    setCampaignList([]);
    setSelectedCampaignId("");

    if (!companyId) return;

    try {
      const response = await getAllCampaignByCompanyId(companyId);
      if (response?.data?.responseCode === 200) {
        const campaignOptions = response?.data?.data?.map((data) => ({
          value: data?.id,
          label: data?.title,
        }));
        setCampaignList(campaignOptions);
      } else {
        toastEmitter("error", response?.data?.message || "Something went wrong!");
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  useEffect(() => {
    const fetchDimensions = async () => {
      if (selectedCampaignId && selectedCompanyId) {
        try {
          const response = await getAllDimenstionbycampaign(selectedCampaignId);
          if (response?.data?.responseCode === 200) {
            const dimensions = response?.data?.data?.map((item) => ({
              label: item?.dimensionName,
              value: item?.id,
            }));
            setDimensionList(dimensions);
          } else {
            setDimensionList([]);
          }
        } catch (err) {
          console.error("Error fetching dimensions", err);
          setDimensionList([]);
        }
      }
    };
    fetchDimensions();
  }, [selectedCampaignId, selectedCompanyId]);

  const handleCampaignSelect = (event) => {
    setSelectedCampaignId(event.target.value);
  };

  useEffect(() => {
    getallCompany();
  }, []);

  useEffect(() => {
    if (selectedCompanyId && selectedCampaignId) {

      setSelectedSection("survey");
    } else {

      setSelectedSection("");
    }
    setSelectedDimensionId("");
    setSelectedDimensionLabel("");
  }, [selectedCompanyId, selectedCampaignId]);

  const chartGroups = {
    "Survey Participation": [
      "OverallParticipation",
      "DimensionParticipationDetails",
      "OverallParticipationDivision",
      "OverallParticipationJobLevel",
    ],
    "Global Results": [
      "RadialDimension",
      "RadialDimensiondetails",
      "OverallHeatmap",
      "WeightedGapChart",
      "DMMSubDimensionresults",
      "MaturityLineOverallversusbenchmark",
    ],
    "Scores by Division": [
      "DemographicDashboardDivision",
      "DemographicDashboardDivisionLevel",
    ],
    "Scores by Hierarchy": ["DemographicDashboardJobLevel", "JobHeatMap"],
    "Scores by Dimension": [
      "MaturityLine",
      "DimensionsRadar",
      "CustomerDimensionCurrent",
      "CustomerDimensionFuture",
      "MaturityBenchmarkLine",
    ],
  };

  const sectionMap = {
    survey: "Survey Participation",
    global: "Global Results",
    division: "Scores by Division",
    hierarchy: "Scores by Hierarchy",
    dimension: "Scores by Dimension",
  };

  //  Determine which chart groups to render
  // const activeSections = selectedSection
  //   ? [sectionMap[selectedSection]]
  //   : Object.values(sectionMap);
  const activeSections = [sectionMap[selectedSection]];

  // const dropdownOptions = [
  //   { label: "Survey Participation", value: "survey" },
  //   { label: "Global Results", value: "global" },
  //   { label: "Scores by Division", value: "division" },
  //   { label: "Scores by Hierarchy", value: "hierarchy" },
  //   {
  //     label: "Scores by Dimension",
  //     value: "dimension",
  //     children: dimensionList,
  //   },
  // ];

  console.log("Fetching dimensions for:", {
    selectedSection,
    selectedCampaignId,
    selectedCompanyId,
  });

  return (
    <div>
      <div className="overall-result">
        <div className="overall-result-content">
          <div className="page-title d-flex justify-content-between ">
            <h5 className="mb-2">Overall Result</h5>
            <div>
              <div className="btn-group">
                <button
                  type="button"
                  className="border-0 bg-transparent p-0 d-flex align-items-center"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Filter
                  <img src={FILTER_ICON} alt="filter" className="ms-2" />
                </button>

                <ul className="dropdown-menu">
                  <li>
                    <button
                      className={`dropdown-item ${selectedFilter === "all"
                        ? "active text-white bg-primary"
                        : ""
                        }`}
                      onClick={() => setSelectedFilter("all")}
                    >
                      All Users (Employee + Assessor)
                    </button>
                  </li>
                  <li>
                    <button
                      className={`dropdown-item ${selectedFilter === "online"
                        ? "active text-white bg-primary"
                        : ""
                        }`}
                      onClick={() => setSelectedFilter("online")}
                    >
                      Only Employee
                    </button>
                  </li>
                  <li>
                    <button
                      className={`dropdown-item ${selectedFilter === "assessor"
                        ? "active text-white bg-primary"
                        : ""
                        }`}
                      onClick={() => setSelectedFilter("assessor")}
                    >
                      Only Assessor
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className={selectedSection === "dimension" ? "col-md-3 mb-4" : "col-md-4 mb-4"}>

              <DropDownWithLabel
                labelName="Select Organization"
                lableclassName="input-label"
                name="companyId"
                showastrict={true}
                options={companyList}
                className="form-control inputText-lable cursor-pointer"
                value={selectedCompanyId}
                handleSelect={handleCompanySelect}
              />
            </div>
            <div className={selectedSection === "dimension" ? "col-md-3 mb-4" : "col-md-4 mb-4"}>
              <DropDownWithLabel
                labelName="Select Campaign"
                lableclassName="input-label"
                name="campaignId"
                showastrict={true}
                options={campaignList}
                className="form-control inputText-lable cursor-pointer"
                value={selectedCampaignId}
                handleSelect={handleCampaignSelect}
                disabled={!selectedCompanyId}
              />
            </div>

            {/* Section Dropdown */}
            <div className={selectedSection === "dimension" ? "col-md-3 mb-4" : "col-md-4 mb-4"}>
              <DropDownWithLabel
                labelName="Select Result Section"
                lableclassName="input-label"
                name="resultSection"
                showastrict={true}
                options={[
                  { label: "Survey Participation", value: "survey" },
                  { label: "Global Results", value: "global" },
                  { label: "Scores by Division", value: "division" },
                  { label: "Scores by Hierarchy", value: "hierarchy" },
                  { label: "Scores by Dimension", value: "dimension" },
                ]}
                className="form-control inputText-lable cursor-pointer"
                value={selectedSection || "survey"}
                handleSelect={(e) => {
                  const value = e.target.value;
                  setSelectedSection(value);
                  if (value !== "dimension") {
                    setSelectedDimensionId("");
                    setSelectedDimensionLabel("");
                  }
                }}
              />
            </div>

            {selectedSection === "dimension" && (
              <div className="col-md-3 mb-4">
                <DropDownWithLabel
                  labelName="Select Dimension"
                  lableclassName="input-label"
                  name="dimension"
                  showastrict={true}
                  options={dimensionList}
                  className="form-control inputText-lable cursor-pointer"
                  value={selectedDimensionId}
                  handleSelect={(e) => {
                    const selectedDim = dimensionList.find(
                      (d) => d.value === e.target.value
                    );
                    setSelectedDimensionId(selectedDim?.value || "");
                    setSelectedDimensionLabel(selectedDim?.label || "");
                  }}
                  disabled={selectedSection !== "dimension"}
                />
              </div>
            )}


            {/* <div className="col-md-6 mb-4">
            
              <MultiDropdown
                labelName="Select Result Section"
                lableclassName="input-label"
                name="resultSection"
                className="form-control inputText-lable cursor-pointer"
                showastrict={true}
                options={dropdownOptions}
                value={selectedDimensionLabel || selectedSection} // show correct name
                handleSelect={(e) => {
                  const selectedValue = e.target.value;

                  // Identify if it’s a child (dimension)
                  const foundParent = dropdownOptions.find(opt =>
                    opt.children?.some(child => child.value === selectedValue)
                  );
                  const selectedChild = foundParent?.children?.find(
                    child => child.value === selectedValue
                  );

                  if (["survey", "global", "division", "hierarchy"].includes(selectedValue)) {
                    setSelectedSection(selectedValue);
                    setSelectedDimensionId("");
                    setSelectedDimensionLabel("");
                  } else if (selectedChild) {
                    setSelectedSection("dimension");
                    setSelectedDimensionId(selectedChild.value);
                    setSelectedDimensionLabel(selectedChild.label);
                  }
                }}
              />
            </div> */}
          </div>
          {!selectedCompanyId && !selectedCampaignId && (
            <div className="selectCompany mb-2">
              <TableHeading
                firstData="Please Select "
                icon={RIGHTARROW_ICON}
                iconshow={RIGHTARROW_ICON}
                TableHeading="mb-0"
                secondclassName="textcolor"
                className="textcolor"
                secondData="Organization"
                thirdData="Campaign"
              />
            </div>
          )}
          {selectedCompanyId && selectedCampaignId && (
            <div className="row my-4">
              {activeSections.some((s) =>
                chartGroups[s]?.includes("OverallParticipation")
              ) && (
                  <div className="col-6 mb-2">
                    <DonutChartWithToolbar
                      selectedCompanyId={selectedCompanyId}
                      selectedCampaignId={selectedCampaignId}
                      graphName="OverallParticipation"
                      type={selectedFilter}
                    />
                  </div>
                )}

              {activeSections.some((s) =>
                chartGroups[s]?.includes("DimensionParticipationDetails")
              ) && (
                  <div className="col-6 mb-2">
                    <DimensionDetails
                      selectedCompanyId={selectedCompanyId}
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                      graphName="DimensionParticipationDetails"
                    />
                  </div>
                )}

              {activeSections.some((s) =>
                chartGroups[s]?.includes("RadialDimension")
              ) && (

                  <div className="col-md-6 mb-2">
                    <RadialDimension
                      selectedCompanyId={selectedCompanyId}
                      selectedCampaignId={selectedCampaignId}
                      graphName="RadialDimension"
                      type={selectedFilter}
                    />
                  </div>
                )}
              {activeSections.some((s) =>
                chartGroups[s]?.includes("RadialDimension")
              ) && (
                  <div className="col-md-6 mb-2">
                    <RadialDimensionHorizontal
                      selectedCompanyId={selectedCompanyId}
                      selectedCampaignId={selectedCampaignId}
                      graphName="RadialDimensiondetails"
                      type={selectedFilter}
                    />
                  </div>

                )}

              {activeSections.some((s) =>
                chartGroups[s]?.includes("OverallHeatmap")
              ) && (
                  <div className="col-md-6 mb-2">
                    <Dimension
                      selectedCompanyId={selectedCompanyId}
                      graphName="OverallHeatmap"
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                    />
                  </div>
                )}

              {activeSections.some((s) =>
                chartGroups[s]?.includes("WeightedGapChart")
              ) && (
                  <div className="col-md-6 mb-2">
                    <WeightedGapChart
                      selectedCompanyId={selectedCompanyId}
                      graphName="WeightedGapChart"
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                    />
                  </div>
                )}

              {activeSections.some((s) =>
                chartGroups[s]?.includes("DMMSubDimensionresults")
              ) && (
                  <div className="col-md-6 mb-2">
                    <DmmSubdimensionsChart
                      selectedCompanyId={selectedCompanyId}
                      graphName="DMMSubDimensionresults"
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                    />
                  </div>
                )}

              {/* {activeSections.some((s) =>
                chartGroups[s]?.includes("MaturityLineOverallversusbenchmark")
              ) && (
                  <div className="col-md-6 mb-2">
                    <MaturityLine
                      selectedCompanyId={selectedCompanyId}
                      graphName="MaturityLineOverallversusbenchmark"
                    />
                  </div>
                )} */}

              {activeSections.some((s) =>
                chartGroups[s]?.includes("OverallParticipationDivision")
              ) && (
                  <div className="col-md-6 mb-2">
                    <OverallParticipationChart
                      selectedCompanyId={selectedCompanyId}
                      graphName="OverallParticipationDivision"
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                    />
                  </div>
                )}

              {activeSections.some((s) =>
                chartGroups[s]?.includes("DemographicDashboardDivision")
              ) && (
                  <div className="col-md-6 mb-2">
                    <DivisionHeatmap
                      selectedCompanyId={selectedCompanyId}
                      graphName="DemographicDashboardDivision"
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                    />
                  </div>
                )}


              {activeSections.some((s) =>
                chartGroups[s]?.includes("DemographicDashboardDivisionLevel")
              ) && (
                  <div className="col-md-6 mb-2">
                    <DivisionLevelHeatmap
                      selectedCompanyId={selectedCompanyId}
                      graphName="DemographicDashboardDivisionLevel"
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                    />
                  </div>
                )}

              {activeSections.some((s) =>
                chartGroups[s]?.includes("OverallParticipationJobLevel")
              ) && (
                  <div className="col-md-6 mb-2">
                    <OverallParticipationChartJobLevel
                      selectedCompanyId={selectedCompanyId}
                      graphName="OverallParticipationJobLevel"
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                    />
                  </div>
                )}

              {activeSections.some((s) =>
                chartGroups[s]?.includes("JobHeatMap")
              ) && (
                  <div className="col-md-6 mb-2">
                    <JobHeatMap
                      selectedCompanyId={selectedCompanyId}
                      graphName="JobHeatMap"
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                    />
                  </div>
                )}


              {activeSections.some((s) =>
                chartGroups[s]?.includes("CustomerDimensionCurrent")
              ) && (
                  <div className="col-md-6 mb-2">
                    <DimenstionCurrentChart
                      selectedCompanyId={selectedCompanyId}
                      graphName="CustomerDimensionCurrent"
                      selectedDimensionId={selectedDimensionId}
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                    />
                  </div>
                )}

              {activeSections.some((s) =>
                chartGroups[s]?.includes("CustomerDimensionFuture")
              ) && (
                  <div className="col-md-6 mb-2">
                    <DimenstionFutureChart
                      selectedCompanyId={selectedCompanyId}
                      graphName="CustomerDimensionFuture"
                      selectedDimensionId={selectedDimensionId}
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                    />
                  </div>
                )}
              {activeSections.some((s) =>
                chartGroups[s]?.includes("DimensionsRadar")
              ) && (
                  <div className="col-md-6 mb-2">
                    <SubDimensionCharts
                      selectedCompanyId={selectedCompanyId}
                      graphName="DimensionsRadar"
                      selectedDimensionId={selectedDimensionId}
                      selectedCampaignId={selectedCampaignId}
                      type={selectedFilter}
                    />
                  </div>
                )}

              {/* {activeSections.some((s) =>
                chartGroups[s]?.includes("MaturityBenchmarkLine")
              ) && (
                <div className="col-md-6 mb-2">
                  <MaturityBenchmark
                    selectedCompanyId={selectedCompanyId}
                    graphName="MaturityBenchmarkLine"
                  />
                </div>
              )} */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewResult;
